// commented the code for revenue column for phase 1

import { useContext, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  Avatar,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useSnackbar } from "../SnackBar";
import CustomTooltip from "../CustomTooltip";
import CustomTable from "../CustomTable";
import SkeletonTable from "../Skeletons/SkeletonTable";
import CustomAccordion from "../CustomAccordion";
import SkeletonAccordion from "../Skeletons/SkeletonAccordion";
import { useTranslation } from "react-i18next";
import MaximumCapacityReachedModal from "../Modals/MaximumCapacityReachedModal";
import KycStatusChip from "../KycStatusChip";
import { AppContext } from "../../Context/AppContext";
import { isKycBlocked } from "../../Constants/kycStatus";

const MyCommunityCard = ({
  data,
  openModal,
  activeTab,
  sortOrder,
  toggleSortOrder,
  isLoading,
  activateCommunity,
  containerRef,
  communityMemberStats,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [expandedId, setExpandedId] = useState(null);
  const [maximumCapacityReachedModal, setMaximumCapacityReachedModal] = useState(false);
  const [selectedCommunityName, setSelectedCommunityName] = useState("");
  const isMobile = useMediaQuery("(max-width:768px)");
  const showSnackbar = useSnackbar();
  const { kycStatus } = useContext(AppContext);
  const kycBlocked = isKycBlocked(kycStatus);

  const { t } = useTranslation("my-community-card");

  const formatDate = (dateStr) => (dateStr ? dateStr.replace(/\//g, ".") : "-");

  const handleMenuClick = (event, supplier) => {
    setAnchorEl(event.currentTarget);
    setSelectedSupplier(supplier);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuText = {
    cursor: "pointer",
    padding: "8px 12px",
    fontSize: "15px",
    fontWeight: "400",
    color: "rgba(62, 63, 76, 0.9)",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: "rgba(245, 246, 250, 1)",
    },
  };
  const ignoreButtonStyle = {
    padding: "6px 8px !important",
    borderRadius: "4px",
    backgroundColor: "#F2F3FB",
    textTransform: "none",
    fontWeight: 500,
    fontSize: 13,
    color: "#B7484A",
    whiteSpace: "nowrap",
  };
  const joinButtonStyle = {
    ...ignoreButtonStyle,
    color: "#248B70",
  };

  const getContactIcons = (community) => {
    const communityManager = community.community_manager;
    const {
      email,
      phone_prefix,
      phonePrefix,
      phone_number,
      phoneNumber
    } = communityManager;
    
    const prefix = phone_prefix || phonePrefix || "";
    const number = phone_number || phoneNumber || "";
    
    const phone = [prefix, number].filter(Boolean).join("");
    
    
    return (
      <Box sx={{ ml: "-8px" }}>
        <CustomTooltip title={t('tootip_email')} tooltipSxStyles={{ paddingY: "5px" }}>
          <IconButton
            onClick={() => {
              navigator.clipboard.writeText(email);
              showSnackbar(`${t('community_manager_copy_email')}`, "success");
            }}
          >
            <img src="/icons/mail-forward-black.svg" alt="mail" />
          </IconButton>
        </CustomTooltip>
        <CustomTooltip title={t('tootip_phone')} tooltipSxStyles={{ paddingY: "5px" }}>
          <IconButton
            onClick={() => {
              navigator.clipboard.writeText(phone);
              showSnackbar(`${t('community_manager_copy_phone')}`, "success");
            }}
          >
            <img src="/icons/phone-outgoing-black.svg" alt="phone" />
          </IconButton>
        </CustomTooltip>
        <CustomTooltip title={t('whatsapp')} tooltipSxStyles={{ paddingY: "5px" }}>
          <IconButton
            onClick={(e) => {
              e.preventDefault();
              window.open(
                `https://api.whatsapp.com/send/?phone=${phone}&text=hello`,
                "_blank",
                "noopener,noreferrer"
              );
            }}
          >
            <img src="/icons/whatsapp-icon-black.svg" alt="whatsapp" />
          </IconButton>
        </CustomTooltip>
      </Box>
  )};

  const getStatusBadge = (community) => {
    const displayStatusRaw = community.status;
    const displayStatus =
      displayStatusRaw?.charAt(0).toUpperCase() +
      displayStatusRaw?.slice(1).toLowerCase();
    const lowerStatus = displayStatusRaw?.toLowerCase();

    return (
      <Box
        sx={{
          padding: "4px 8px",
          borderRadius: "80px",
          background: "rgba(28, 160, 138, 0.16)",
          color: "rgba(28, 160, 138, 1)",
          fontSize: "12px",
          fontWeight: 400,
          display: "inline-block",
          ...(lowerStatus?.startsWith("paused") && {
            background: "rgba(255, 151, 51, 0.16)",
            color: "rgba(255, 151, 51, 1)",
          }),
        }}
      >
        {t('statuses.' + displayStatus)}
      </Box>
    );
  };

  const getActionButton = (community) => {
    const lowerStatus = community.status?.toLowerCase();
    const isPaused = lowerStatus?.startsWith("paused");
    // The supplier may only lift a pause they started themselves. A CM-initiated
    // pause (paused_by_cm) is read-only here — no activate/pause toggle is shown.
    const isPausedBySupplier = lowerStatus === "paused_by_supplier";

    const renderButton = (label, actionType, sx = joinButtonStyle) => (
      <Button
        sx={sx}
        onClick={() => {
          if (
            actionType === "join-community" &&
            communityMemberStats.currentMembersStat >=
              communityMemberStats.maxMembersStat
          ) {
            setSelectedCommunityName(community.community_name);
            setMaximumCapacityReachedModal(true);
          } else {
            actionType === "activate-community"
              ? activateCommunity(community)
              : openModal(community, actionType);
          }
        }}
      >
        {label}
      </Button>
    );

    const renderMenuItem = (label, actionType) => (
      <MenuItem
        sx={menuText}
        onClick={() => {
          handleMenuClose();
          actionType === "activate-community"
            ? activateCommunity(community)
            : openModal(community, actionType);
        }}
      >
        {label}
      </MenuItem>
    );

    if (activeTab === 1) {
      if (isMobile) {
        return (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            {renderButton(t('view_offer'), "view-offer")}

            {isPausedBySupplier
              ? renderButton(t('activate_community'), "activate-community")
              : isPaused
                ? null
                : renderButton(
                    t('pause_community'),
                    "pause-community",
                    ignoreButtonStyle
                  )}
            {renderButton(t('leave_community'), "Leave-community", ignoreButtonStyle)}
          </Box>
        );
      }

      return (
        <Box>
          <IconButton
            aria-label="more"
            aria-controls="dots-menu"
            aria-haspopup="true"
            onClick={(e) => handleMenuClick(e, community)}
          >
            <MoreVertIcon />
          </IconButton>

          <Menu
            id="dots-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && selectedSupplier?.id === community.id}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
              elevation: 0,
              sx: {
                marginTop: "5px",
                borderRadius: "12px",
                boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.16)",
                padding: "4px 12px",
                minWidth: "212px",
              },
            }}
          >
            {renderMenuItem(t('view_offer'), "view-offer")}
            {isPausedBySupplier
              ? renderMenuItem(t('activate_community'), "activate-community")
              : isPaused
                ? null
                : renderMenuItem(t('pause_community'), "pause-community")}
            {renderMenuItem(t('leave_community'), "Leave-community")}
          </Menu>
        </Box>
      );
    }

    if (activeTab === 2) {
      return (
        <Box
          sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "15px" }}
        >
          {/* Joining means sending the community an offer, which is exactly
              what an unverified supplier may not do — so the invitation waits
              while "ignore" stays available. */}
          {kycBlocked ? (
            /* The table has no room for a chip without widening the column, so
               here the explanation rides on the disabled button itself. */
            <KycStatusChip>
              <Button sx={joinButtonStyle} disabled>
                {t('join')}
              </Button>
            </KycStatusChip>
          ) : (
            renderButton(t('join'), "join-community")
          )}
          {renderButton(t('ignore'), "ignore-community", ignoreButtonStyle)}
        </Box>
      );
    }

    return renderButton(t('view'), "waiting-approval");
  };

  // const revenueColumn = (community) => {
  //   const revenue = community.revenue;
  //   const roundedRevenue = Math.floor(revenue);
  //   const hasDecimal = revenue % 1 !== 0;

  //   const formattedRounded = roundedRevenue.toLocaleString("en-US", {
  //     style: "currency",
  //     currency: "ILS",
  //     maximumFractionDigits: 0,
  //   });

  //   const fullFormatted = revenue.toLocaleString("en-US", {
  //     style: "currency",
  //     currency: "ILS",
  //   });

  //   return hasDecimal ? (
  //     <CustomTooltip
  //       title={fullFormatted}
  //       tooltipSxStyles={{ paddingY: "5px" }}
  //     >
  //       <Typography
  //         sx={{
  //           fontSize: "14px",
  //           color: "rgba(62, 63, 76, 1)",
  //           fontWeight: 400,
  //           width: "max-content"
  //         }}
  //       >
  //         {formattedRounded}
  //       </Typography>
  //     </CustomTooltip>
  //   ) : (
  //     <Typography
  //       sx={{
  //         fontSize: "14px",
  //         color: "rgba(62, 63, 76, 1)",
  //         fontWeight: 400,
  //         width: "max-content"
  //       }}
  //     >
  //       {formattedRounded}
  //     </Typography>
  //   );
  // };

  const columns = [
    {
      id: "community",
      label: t("table_columns.community_name"),
      render: (community) => (
        <Box display="flex" alignItems="center">
          <Avatar
            alt={activeTab === 1 ? community.name : community.community_name}
            src={activeTab === 1 ? community.image : community.community_image}
            sx={{ width: 32, height: 32 }}
          />
          <Box
            ml="16px"
            sx={{
              maxWidth: "220px",
            }}
          >
            <CustomTooltip
              title={
                activeTab === 1 ? community.name : community.community_name
              }
              tooltipSxStyles={{ paddingY: "5px" }}
            >
              <Typography
                sx={{
                  fontSize: "15px",
                  color: "rgba(62, 63, 76, 0.9)",
                  fontWeight: 500,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "max-content",
                }}
              >
                {activeTab === 1 ? community.name : community.community_name}
              </Typography>
            </CustomTooltip>
          </Box>
        </Box>
      ),
      headerStyle: { width: "302px" },
      cellStyle: { width: "302px" },
    },
    {
      id: "members",
      label: t('table_columns.members'),
      render: (community) => (
        <Typography
          sx={{
            fontSize: "14px",
            color: "rgba(62, 63, 76, 1)",
            fontWeight: 400,
          }}
        >
          {community.member_count}
        </Typography>
      ),
    },
    {
      id: "location",
      label: t('table_columns.location'),
      render: (community) => (
        <CustomTooltip
          title={community.location}
          tooltipSxStyles={{ paddingY: "5px" }}
        >
          {community.location.length > 18
            ? community.location.slice(0, 18) + "..."
            : community.location}
        </CustomTooltip>
      ),
    },
    ...(activeTab === 1 || activeTab === 3
      ? [
          {
            id: "discount",
            label: t('table_columns.discount'),
            render: (community) => (
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "rgba(62, 63, 76, 1)",
                  fontWeight: 400,
                }}
              >
                {community.supplier_discount}%
              </Typography>
            ),
          },
        ]
      : []),
    // ...(activeTab === 1
    //   ? [
    //       {
    //         id: "revenue",
    //         label:  t('table_columns.revenue'),
    //         render: (community) => revenueColumn(community),
    //       },
    //     ]
    //   : []),

    ...(activeTab === 2
      ? [
          {
            id: "tags",
            label:  t('table_columns.tags'),
            render: (community) => (
              <CustomTooltip
                title={community.tags.map((tag) => tag).join(",  ")}
                tooltipSxStyles={{ paddingY: "5px" }}
              >
                {community.tags.map((tag) => tag).join(",  ").length > 18
                  ? community.tags
                      .map((tag) => tag)
                      .join(",  ")
                      .slice(0, 18) + "..."
                  : community.tags.map((tag) => tag).join(",  ")}
              </CustomTooltip>
            ),
          },
        ]
      : []),
    {
      id: "date",
      label:
        activeTab === 1
          ? t('table_columns.selling_since')
          : activeTab === 2
          ? t('table_columns.request_from')
          : t('table_columns.submission_date'),
      render: (community) =>
        formatDate(
          activeTab === 1
            ? community.contract_start
            : activeTab === 2
            ? community.request_date
            : community.submission_date
        ),
      headerRender: () => (
        <Box
          onClick={toggleSortOrder}
          sx={{
            cursor: "pointer",
            userSelect: "none",
            display: "flex",
            alignItems: "center",
          }}
        >
          {activeTab === 1
            ? t('table_columns.selling_since')
            : activeTab === 2
            ? t('table_columns.request_from')
            : t('table_columns.submission_date')}
          {sortOrder === "asc" ? (
            <KeyboardArrowDownIcon />
          ) : (
            <KeyboardArrowUpIcon />
          )}
        </Box>
      ),
      headerStyle: { cursor: "pointer", userSelect: "none" },
    },
    {
      id: "contact",
      label: t('table_columns.contact'),
      render: (community) => getContactIcons(community),
    },

    ...(activeTab === 1
      ? [
          {
            id: "status",
            label:  t('table_columns.status'),
            render: (community) => getStatusBadge(community),
          },
        ]
      : []),
    {
      id: "actions",
      label: activeTab === 1 ? "" : t('table_columns.actions'),
      render: (community) => getActionButton(community),
    },
  ];

  const mobileDetails = (community) => [
    { label:  t('table_columns.members'), value: community.member_count },
    { label: t('table_columns.location'), value: community.location },
    ...(activeTab === 1 || activeTab === 3
      ? [{ label: t('table_columns.discount'), value: community.supplier_discount + "%" }]
      : []),
    // ...(activeTab === 1
    //   ? [
    //       {
    //         label:  t('table_columns.revenue'),
    //         value: revenueColumn(community),
    //       },
    //     ]
    //   : []),

    ...(activeTab === 2
      ? [
          {
            label:  t('table_columns.tags'),
            value:
              community.tags.map((tag) => tag).join(",  ").length > 18
                ? community.tags
                    .map((tag) => tag)
                    .join(",  ")
                    .slice(0, 18) + "..."
                : community.tags.map((tag) => tag).join(",  "),
          },
        ]
      : []),
    {
      label:
        activeTab === 1
          ? t('table_columns.selling_since')
          : activeTab === 2
          ? t('table_columns.request_from')
          : t('table_columns.submission_date'),
      value: formatDate(
        activeTab === 1
          ? community.contract_start
          : activeTab === 2
          ? community.request_date
          : community.submission_date
      ),
    },
    { label: t('table_columns.contact'), value: getContactIcons(community) },
    ...(activeTab === 1
      ? [{ label:  t('table_columns.status'), value: getStatusBadge(community) }]
      : []),
  ];

  const handleChange = (memberId) => (event, isExpanded) => {
    setExpandedId(isExpanded ? memberId : null);
  };
  
  return (
    <>
      {isMobile ? (
        isLoading ? (
          <SkeletonAccordion />
        ) : (
          <Box
            ref={containerRef}
            className="custom-scrollbar"
            sx={{ overflowY: "auto", height: "100%", paddingRight: "8px" }}
          >
            {data.map((community, idx) => {
              const communityId = community.community_id || community.id;
              return (
              <CustomAccordion
                key={idx}
                expanded={expandedId === communityId}
                onChange={handleChange(communityId)}
                imageUrl={community.image || community.community_image}
                summaryContent={
                  <Box>
                    <Typography
                      color="rgba(62, 63, 76, 0.9)"
                      sx={{
                        fontSize: "15px",
                        fontWeight: 500,
                      }}
                    >
                      {community.name || community.community_name}
                    </Typography>
                  </Box>
                }
                details={mobileDetails(community)}
                actions={getActionButton(community)}
              />
            )})}
          </Box>
        )
      ) : isLoading ? (
        <SkeletonTable columns={columns} rowCount={5} />
      ) : (
        <CustomTable columns={columns} data={data} containerRef={containerRef} />
      )}

      <MaximumCapacityReachedModal
        open={maximumCapacityReachedModal}
        onClose={() => {
          setMaximumCapacityReachedModal(false);
          setSelectedCommunityName("");
        }}
        maxClients={communityMemberStats?.maxMembersStat}
        communityName={selectedCommunityName}
      />
    </>
  );
};

export default MyCommunityCard;
